import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [ "dropZone", "fileInput", "overlayTemplate" ]

  dragOver(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.add('drag-over')
  }

  dragEnter(event) {
    event.preventDefault()
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove('drag-over')
  }

  drop(event) {
    event.preventDefault()
    this.dropZoneTarget.classList.remove('drag-over')
    this.handleFiles(event.dataTransfer.files)
  }

  handleFileSelect(event) {
    this.handleFiles(event.target.files)
  }

  handleFiles(files) {
    if (files && files[0]) {
      const file = files[0]

      if (!file.type.match(/image\/*/)) {
        alert('不支持的檔案類型: ' + file.name)
        return
      }

      const reader = new FileReader()
      reader.onload = (e) => {
        const template = this.overlayTemplateTarget.cloneNode(true)
        this.dropZoneTarget.innerHTML = `
          <div class="image-container">
            <img src="${e.target.result}" class="w-full h-full object-contain">
            ${template.innerHTML}
          </div>`
      }
      reader.readAsDataURL(file)
      this.fileInputTarget.files = files
    }
  }

  triggerFileInput() {
    this.fileInputTarget.click()
  }
}